/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerRestApiSourceComponent', [
    'DesignerBaseSourceAndDestinationComponent',

    function (DesignerBaseSourceAndDestinationComponent) {
      const AUTHENTICATION_TYPES = {
        NONE: 'none',
        BASIC: 'basic',
        CONNECTION: 'connection',
      };

      function DesignerRestApiSourceComponent() {
        DesignerBaseSourceAndDestinationComponent.apply(this);

        this.url = null;
        this.method = null;
        this.username = null;
        this.password = null;
        this.body = null;
        this.headers = null;
        this.response_type = null;
        this.use_pagination = null;
        this.pagination_scheme = null;
        this.pagination_sleep_interval = null;
        this.max_requests = null;
        this.json_path = null;
        this.rest_api_connection_id = null;
      }

      DesignerRestApiSourceComponent.prototype = new DesignerBaseSourceAndDestinationComponent();
      DesignerRestApiSourceComponent.prototype.getData = function () {
        const data = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);

        const connection = this.connection.getData();

        _.extend(data, {
          connection,
          rest_api_connection_id: String(connection.id || ''),
          url: this.url || '',
          method: this.method || this.defaults.method,
          username: this.username || '',
          password: this.password || '',
          body: this.body || '',
          headers: this.headers || [],
          authentication: this.authentication || 'none',
          response_type: this.response_type || this.defaults.response_type,
          use_pagination: angular.isDefined(this.use_pagination) ? this.use_pagination : this.defaults.use_pagination,
          pagination_scheme: this.pagination_scheme || this.defaults.pagination_scheme,
          pagination_sleep_interval: this.pagination_sleep_interval || this.defaults.pagination_sleep_interval,
          max_requests: this.max_requests || '',
          json_path: this.json_path || this.defaults.json_path,
        });

        return data;
      };

      DesignerRestApiSourceComponent.prototype.getFormData = function () {
        if (this.connection && this.connection.type && this.connection.id) {
          this.authentication = AUTHENTICATION_TYPES.CONNECTION;
        } else if ((this.username && this.username.length) || (this.password && this.password.length)) {
          this.authentication = AUTHENTICATION_TYPES.BASIC;
        } else {
          this.authentication = AUTHENTICATION_TYPES.NONE;
        }

        const formData = {};
        const baseData = DesignerBaseSourceAndDestinationComponent.prototype.getData.call(this);
        const baseFormData = DesignerBaseSourceAndDestinationComponent.prototype.getFormData.call(this);
        const componentData = this.getData();

        _.extend(formData, baseData);
        _.extend(formData, componentData);
        _.extend(formData, baseFormData);
        _.extend(formData, {
          authentication: this.authentication,
        });

        return formData;
      };

      DesignerRestApiSourceComponent.prototype.setFormData = function (data) {
        if (
          data.authentication === AUTHENTICATION_TYPES.CONNECTION ||
          data.authentication === AUTHENTICATION_TYPES.NONE
        ) {
          data.username = '';
          data.password = '';
        }

        if (data.authentication === AUTHENTICATION_TYPES.BASIC || data.authentication === AUTHENTICATION_TYPES.NONE) {
          data.connection.type = null;
          data.connection.id = null;
        }

        this.setData(data);

        DesignerBaseSourceAndDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerRestApiSourceComponent.prototype.setData = function (data) {
        // Fix for old packages
        if (typeof data.use_pagination === 'string') {
          data.use_pagination = false;
        }

        this.connection.setData(data.connection);
        this.rest_api_connection_id = data.connection && data.connection.id ? String(data.connection.id) : '';
        this.url = data.url;
        this.method = data.method;
        this.username = data.username;
        this.password = data.password;
        this.body = data.body;
        this.headers = data.headers;
        this.response_type = data.response_type;
        this.use_pagination = data.use_pagination;
        this.pagination_scheme = data.pagination_scheme;
        this.pagination_sleep_interval = data.pagination_sleep_interval;
        this.max_requests = data.max_requests;
        this.json_path = data.json_path;

        DesignerBaseSourceAndDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerRestApiSourceComponent;
    },
  ]);
})(window.angular);
